import z, { ZodNumber } from 'zod'

export const zPercentage: ZodNumber = z.number().min(0).max(100).multipleOf(0.01)
